<template>
  <div v-if="data">
    <div class="container" v-if="!pageReady">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4"></div>
        <div class="col-sm"></div>
      </div>
    </div>
    <div class="container" v-if="pageReady">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4">
          <!-- Progress -->
          <div class="progress">
            <div class="progress-bar" role="progressbar" style="width: 33%"
              aria-valuenow="33" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <!-- Watermark - to be removed -->
          <p class="watermark" v-html="data.misc.watermark"></p>
          <div class="consent-text" v-html="data.consent.consentText"></div>
          <div class="clearfix--min"></div>
          <div class="btn-group btn-group-toggle btn-block">
            <label id="consentUsage" :class="consentUsage === true ? 'active' : ''"
              class="btn btn-primary btn-consent btn-lg">
              <input type="checkbox"
              v-model="consentUsage"
              v-bind:value="true"
              autocomplete="off"> {{ data.misc.consentApproveBtn }}
            </label>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-consent btn-secondary btn-lg btn-block"
            data-toggle="modal" data-target="#decline-approval" v-html="data.misc.noThanksBtn"></button>
          <div class="clearfix"></div>
          <small class="text-muted" v-html="data.consent.consentDisclaimer"></small>
          <div class="clearfix"></div>
          <div class="consent-text" v-html="data.consent.consentResearchText"></div>
          <div class="clearfix--min"></div>
          <div class="btn-group btn-group-toggle btn-block">
            <label class="btn btn-outline-secondary btn-lg" :class="consentResearch === true ? 'active' : ''">
              <input type="radio"
              v-model="consentResearch"
              v-bind:value="true"
              autocomplete="off">Ja
            </label>
            <div class="clearfix"></div>
            <label class="btn btn-outline-secondary btn-lg" :class="consentResearch === false ? 'active' : ''">
              <input type="radio"
              v-model="consentResearch"
              v-bind:value="false"
              autocomplete="off">Nej
            </label>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-give-consent btn-lg btn-block"
            :disabled="!consentUsage || (consentResearch === null)" @click="giveConsent()">
            Gå vidare
          </button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <!-- Modal - Decline approval -->
    <div id="decline-approval" class="modal fade" role="dialog" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <p v-html="data.consent.declineApprovalModal"></p>
            <button class="btn btn-consent btn-primary btn-lg btn-block" data-dismiss="modal">OK</button>
            <div class="clearfix"></div>
            <button class="btn btn-consent btn-secondary btn-lg btn-block"
              @click="declineApproval()" v-html="data.misc.consentDeclineBtn"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import config from '../../config/index.js'
import { showDelayText } from '../plugins/delayhandler'
import { parseJwt } from '../plugins/jwtparser'
import axios from '../plugins/axios'
import $ from 'jquery'

export default {
  name: 'consent',
  components: {},
  data () {
    return {
      data: null,
      patientStates: [],
      consentUsage: false,
      consentResearch: null,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa',
      pageReady: false
    }
  },
  methods: {
    userLoggedIn (djwt) {
      this.$store.commit('setLogin', true)
      this.$store.commit('setName', djwt.givenName + ' ' + djwt.surName)
      sessionStorage.setItem('userLoggedIn', true)
      sessionStorage.setItem('userFullName', djwt.givenName + ' ' + djwt.surName)
    },
    async getJwt () {
      let loader = this.$loading.show({
        default: showDelayText(config.delayText, config.delayTimer)
      })
      const sessionId = sessionStorage.getItem('sessionId')
      const uri = localStorage.getItem('uri')
      axios.postToken(uri, sessionId).then((response) => {
        if (response) {
          loader.hide()
          sessionStorage.setItem('jwt', response.data)
          const decodedJwt = parseJwt(response.data)
          if (decodedJwt) {
            this.userLoggedIn(decodedJwt)
            this.decideRouteByState(decodedJwt)
          }
        }
      }, (error) => {
        if (error.response) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        }
      })
    },
    async devGetJwt () {
      if (sessionStorage.getItem('temp') && (this.isDev || this.isQa)) {
        let loader = this.$loading.show({
          default: showDelayText(config.delayText, config.delayTimer)
        })
        const temp = JSON.parse(sessionStorage.getItem('temp'))
        axios.postTokenTest(config.tokenUri + config.testUri, temp).then((response) => {
          if (response) {
            loader.hide()
            sessionStorage.setItem('jwt', response.data)
            const decodedJwt = parseJwt(response.data)
            if (decodedJwt) {
              this.userLoggedIn(decodedJwt)
              this.decideRouteByState(decodedJwt)
            }
          }
        }, (error) => {
          if (error.response) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          }
        })
      }
    },
    decideRouteByState (dJwt) {
      let loader = this.$loading.show({
        default: showDelayText(config.delayText, config.delayTimer)
      })
      this.patientStates.push(
        { name: 'hasOptedOut', value: (dJwt.consent === 'OptOut') },
        { name: 'hasGivenConsent', value: (dJwt.consent === 'True') },
        { name: 'hasChosenService', value: dJwt.service }
      )
      for (var ps = 0; ps < this.patientStates.length; ++ps) {
        var state = this.patientStates[ps]
        if (state.name === 'hasOptedOut' && state.value) {
          // we push this user to optout
          this.$router.push('/optout')
          break
        }
        if (state.name === 'hasGivenConsent' && state.value) {
          const service = this.patientStates.find(element => element.name === 'hasChosenService').value
          if (service) {
            // consent given, service chosen - route to end of line
            const path = service === 'MessageBox_1177' ? 'radio_1177' : 'radio_calls_sms'
            sessionStorage.setItem('path', path)
            this.$router.push('/nextstep')
            break
          } else {
            // consent given, service is not - route to choice of service
            this.$router.push('/consentpath')
            break
          }
        }
      }
      this.pageReady = true
      loader.hide()
    },
    giveConsent () {
      let loader = this.$loading.show({
        default: showDelayText(config.delayText, config.delayTimer)
      })
      const pharmacy = localStorage.getItem('pharmacy')
      axios.postConsent(config.consentUri, this.consentUsage, this.consentResearch, pharmacy).then((response) => {
        if (response) {
          loader.hide()
          this.$router.push('/consentpath')
        }
      }, (error) => {
        if (error.response) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        }
      })
    },
    declineApproval () {
      $('#decline-approval').modal('hide')
      axios.postConsent(config.consentUri, false).then((response) => {
        if (response) {
          this.$router.push('endpart')
        }
      }, (error) => {
        if (error.response) {
          window.location.href = window.location.origin.concat('/error')
        }
      })
    }
  },
  async beforeMount () {
    sessionStorage.removeItem('path')
    const devSession = sessionStorage.getItem('devSession') === 'true'
    if (!devSession) {
      await this.getJwt()
    }
    await this.devGetJwt()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          consent(locale: ` + sessionStorage.getItem('language') + `) {
            consentText
            consentResearchText
            consentDisclaimer
            gdprModal
            declineApprovalModal
          }
          misc(locale: ` + sessionStorage.getItem('language') + `) {
            consentApproveBtn
            consentDeclineBtn
            noThanksBtn
            watermark
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
button:disabled {
  opacity: 0.3;
}
.active::after {
  content: " ✔";
}
.btn-give-consent {
  background: #001965 !important;
  color: #fff;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .watermark {
    color: rgba(255, 5, 5, 0.12);
    letter-spacing: -5px;
  }
  .consent-text {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  .container {
    margin-bottom: -6.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Consent.vue